import type { CompanyProduct } from "../hooks/useCompanyProducts";

/** Match company products by name or EAN for Ant Design Select search. */
export const companyProductMatchesSearch = (
  product: Pick<CompanyProduct, "name" | "ean">,
  input: string
): boolean => {
  const query = input.trim().toLowerCase();
  if (!query) return true;
  const name = (product.name ?? "").toLowerCase();
  const ean = product.ean != null ? String(product.ean) : "";
  return name.includes(query) || ean.includes(query);
};
